module.exports = __webpack_public_path__ + "img/51000.93056d9c.jpg";